import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * ReCAPTCHA Component
 * 
 * To use this component, you need to:
 * 1. Get your reCAPTCHA site key from https://www.google.com/recaptcha/admin
 * 2. Add it to your .env file as: REACT_APP_RECAPTCHA_SITE_KEY=your_site_key_here
 * 3. For backend verification, use the secret key (keep it server-side only)
 */

const ReCaptcha = forwardRef((props, ref) => {
  const { onChange, onExpired, onErrored, theme = 'light', size = 'normal' } = props;
  
  // Get the site key from environment variable
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  // If no site key is configured, show a warning in development
  if (!siteKey) {
    if (process.env.NODE_ENV === 'development') {
      return (
        <div style={{ 
          padding: '10px', 
          border: '2px dashed #ff6b6b', 
          borderRadius: '4px',
          backgroundColor: '#ffe0e0',
          color: '#c92a2a',
          marginBottom: '1rem'
        }}>
          <strong>⚠️ ReCAPTCHA Not Configured</strong>
          <p style={{ margin: '5px 0 0 0', fontSize: '14px' }}>
            Please add REACT_APP_RECAPTCHA_SITE_KEY to your .env file
          </p>
        </div>
      );
    }
    return null;
  }

  return (
    <ReCAPTCHA
      ref={ref}
      sitekey={siteKey}
      onChange={onChange}
      onExpired={onExpired}
      onErrored={onErrored}
      theme={theme}
      size={size}
    />
  );
});

ReCaptcha.displayName = 'ReCaptcha';

export default ReCaptcha;
